import _FlaskIcon from "./flask.png";
import _SqliteIcon from "./sqlite.png";
import _DjangoIcon from "./django.png";
import _PostgresqlIcon from "./postgresql.png";
import _FlutterIcon from "./flutter.png";
import _WordpressIcon from "./wordpress.png";
import _GolangIcon from "./golang.png";
import _NextjsIcon from "./nextjs.png";
import _PythonIcon from "./python.svg";
import _HuggingFaceIcon from "./huggingface.svg";
import _PytorchIcon from "./pytorch.png";

export type Icon = { src: string; alt: string };

export const FlaskIcon = { src: _FlaskIcon, alt: "Flask icon" };
export const SqliteIcon = { src: _SqliteIcon, alt: "SQLite icon" };
export const DjangoIcon = { src: _DjangoIcon, alt: "Django icon" };
export const PostgresqlIcon = { src: _PostgresqlIcon, alt: "PostgreSQL icon" };
export const FlutterIcon = { src: _FlutterIcon, alt: "Flutter icon" };
export const WordPressIcon = { src: _WordpressIcon, alt: "WordPress icon" };
export const GolangIcon = { src: _GolangIcon, alt: "Golang icon" };
export const NextjsIcon = { src: _NextjsIcon, alt: "Next.js icon" };
export const PythonIcon = { src: _PythonIcon, alt: "Python icon" };
export const HuggingFaceIcon = {
  src: _HuggingFaceIcon,
  alt: "Hugging Face icon",
};
export const PytorchIcon = { src: _PytorchIcon, alt: "Pytorch icon" };
